import { useDropzone } from "react-dropzone"
import { Box } from "@mui/material"
import RejectionFiles from "minimals-template/components/upload/RejectionFiles"
import { DropZoneStyle } from "./UploadSingleFile"
import { useBoundValue } from "lib/@components/binding/use-bound-value"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { AcceptedFiles } from "./accepted-files"
import { DocumentUploadZone } from "./document-upload-zone"

export default function UploadDocumentFile({
    fileSelectText = "Select file",
    accept,
    multiple = false,
    targetName = "files",
}) {
    const [files, setFiles] = useBoundValue(targetName)
    const { refresh } = useBoundContext()
    const { getRootProps, getInputProps, isDragActive, isDragReject, fileRejections } = useDropzone({
        multiple: multiple,
        accept: accept,
        onDrop: handleDrop,
        ...(!!multiple && { validator: duplicateFileValidator }),
    })

    return (
        <Box>
            <DropZoneStyle
                {...getRootProps()}
                sx={{
                    ...(isDragActive && { opacity: 0.72 }),
                    ...(isDragReject && {
                        color: "error.main",
                        borderColor: "error.light",
                        bgcolor: "error.lighter",
                    }),
                }}
            >
                <input {...getInputProps()} data-cy="file-upload-input" />
                <DocumentUploadZone header={fileSelectText} />
            </DropZoneStyle>

            {fileRejections.length > 0 && <RejectionFiles fileRejections={fileRejections} />}
            {files?.length > 0 && <AcceptedFiles files={files} onRemoveFile={handleRemoveFile} />}
        </Box>
    )

    function handleDrop(acceptedFiles) {
        multiple ? setFiles((prevFiles) => [...prevFiles, ...acceptedFiles]) : setFiles(acceptedFiles)
        refresh()
    }

    function handleRemoveFile(file) {
        setFiles((prevFiles) => prevFiles.filter((prevFile) => prevFile.path !== file.path))
        refresh()
    }

    function duplicateFileValidator(file) {
        if (files.some((uploadedFile) => uploadedFile.name === file.name)) {
            return {
                code: "duplicate-file",
                message: `File has already been selected`,
            }
        }
        return null
    }
}
